import APITemplate from '@/api/APITemplate'

const url = '/service'

const template = APITemplate(url)
export default {
  ...template,
  getServes (config) {
    const params = new URLSearchParams()
    params.append('expand', 'car')
    if (config && config.page !== undefined && config.pageSize !== undefined) {
      params.append('pagination[page]', (config.page - 1).toString())
      params.append('pagination[pageSize]', config.pageSize)
    }
    if (config && config.searchText !== undefined) {
      params.append('search', config.searchText)
    }
    return template.fetchGet(`${url}/search?${params}`)
  }
}
